import { useTranslation } from '@bcba/react-hooks';
import { RadioField } from '../../RadioField/RadioField';
import { YES_NO_OPTIONS, YesNoOption } from '@bcba/types';

type Props = {
  label: string;
  defaultValue: YesNoOption;
};

export const ReadOnlyYesNoRadio = ({ label, defaultValue }: Props) => {
  const { t } = useTranslation();
  return (
    <RadioField
      name=""
      label={label}
      options={[
        {
          value: YES_NO_OPTIONS.YES,
          label: t('common.yes'),
        },
        {
          value: YES_NO_OPTIONS.NO,
          label: t('common.no'),
        },
      ]}
      defaultValue={defaultValue}
      rhfOptions={{ disabled: true }}
    />
  );
};
